module.exports = __webpack_public_path__ + "static/media/facilimg1.80d8aee5.jpg";